import React, { Component } from "react";
import { NavBar, SideBar, Footer } from "../../components";
import PouchDB from "pouchdb";
import PouchdbFind from "pouchdb-find";
import "react-toastify/dist/ReactToastify.css";
import { ToastContainer, toast } from "react-toastify";
import produtoModel from "../../models/produto";
const { formatarReal } = require("../../utils");
PouchDB.plugin(PouchdbFind);

export default class ProdutoDestaque1 extends Component {
  constructor(props) {
    super(props);
    this.load = this.load.bind(this);

    this.state = {
      produtos: [],
    };
  }

  async componentDidMount() {
    localStorage.removeItem("idProdutoFocus");
    localStorage.setItem("existeProdutoAdicionado", "false");
    let db = await new PouchDB(this.props.getBaseUrlBanco(), {
      auth: this.props.getUserBanco(),
      skipSetup: true,
    });
    await this.setState(
      {
        db: db,
      },
      async () => {
        await this.load();
      }
    );
  }

  async load() {
    this.setState({ exibirLoading: true }, async () => {
      let produtosBusca = [];

      produtosBusca = await produtoModel.findAllDestaque(
        this.state.db
        // this.state.skip
      );

      for (let produto of produtosBusca) {
        produto.preco.precoUnitComImpostosFinal =
          produto.preco.precoUnitComImpostos;
      }

      if (produtosBusca.length) {
        this.setState((prevState) => ({
          produtos: [...this.state.produtos, ...produtosBusca],
          // skip: prevState.skip + 25,
          // exibirLoading: false,
        }));
      } else {
        this.setState({ hasMore: false, exibirLoading: false });
      }
    });
  }

  render() {
    return (
      <React.Fragment>
        <ToastContainer
          position="top-right"
          autoClose={3000}
          hideProgressBar={false}
          newestOnTop={false}
          closeOnClick
          rtl={false}
          pauseOnVisibilityChange
          draggable
          pauseOnHover
        />
        <div className="container-scroller font-app">
          <NavBar title="Produtos em Destaque" />
          <div className="container-fluid page-body-wrapper">
            <SideBar itemActive={"produtoDestaque"} />
            <div className="main-panel">
              <div className="content-wrapper">
                {/* <TitleAndDescription
                  title={`Cadastrar Pedido`}
                  description="Adicionar um novo pedido"
                /> */}

                <div className="row font-size-13">
                  <div className="col-md-12 grid-margin stretch-card">
                    <div className="card">
                      <div className="card-body dashboard-tabs p-0">
                        <div className="tab-content py-0 px-0">
                          <div
                            className="tab-pane fade show active"
                            id="overview"
                            role="tabpanel"
                            aria-labelledby="overview-tab"
                          >
                            <div className="d-flex flex-wrap justify-content-xl-between">
                              <div
                                style={{
                                  padding: "15px",
                                  float: "left",
                                  width: "100%",
                                }}
                              >
                                <div className="row">
                                  <React.Fragment>
                                    <div className="container">
                                      {/* container-pesquisa-add-itens */}
                                    </div>{" "}
                                    {/* container */}
                                    {this.state.mensagemBusca !== "" && (
                                      <div className="float-left width-100 d-flex">
                                        <div className="container float-left width-100 text-center font-13">
                                          {this.state.mensagemBusca}
                                        </div>
                                      </div>
                                    )}
                                    <div
                                      className="container-itens"
                                      style={{
                                        float: "left",
                                        width: "100%",
                                        paddingBottom: "65px",
                                        // backgroundColor: this.state.produtos
                                        //   .length
                                        //   ? "rgb(217, 217, 217)"
                                        //   : "white",
                                      }}
                                    >
                                      <div
                                        className="container d-flex"
                                        style={{ flexWrap: "wrap" }}
                                      >
                                        {this.state.produtos.map((produto) => (
                                          // <div
                                          //   className="owl-item active"
                                          //  // style={{ width: "228px" }}
                                          // >

                                          <React.Fragment>
                                            <div className="col-md-3 product-list__item-home">
                                              <article className="product-variation">
                                                <figure className="product-variation__figure text-center">
                                                  <a
                                                    className="product-variation__image-container link-teste"
                                                    href="#"
                                                    onClick={() => {
                                                      this.props.history.push(
                                                        `/produtos/destaque-detalhe?id=${produto._id}`
                                                      );
                                                    }}
                                                  >
                                                    <img
                                                     // src="../images/no-image.png"
                                                      src={produto.imagemPrincipal}
                                                      // src={
                                                      //   produto.imagemPrincipal
                                                      // }
                                                      className="product-variation__image"
                                                      id="img-34883"
                                                      loading="lazy"
                                                      style={{ width: "150px" }}
                                                    />
                                                  </a>
                                                </figure>

                                                <div className="product-variation__details">
                                                  <a
                                                    className="product-variation__name link-teste"
                                                    // href="/loja/ibirama/produto/1802887/detergente-sanitario-pastilha-adesiva-lavanda-pato-20-de-desconto-com-3-unidades"
                                                    href="#"
                                                    style={{
                                                      color: "#333",
                                                    }}
                                                    onClick={() => {
                                                      this.props.history.push(
                                                        `/produtos/destaque-detalhe?id=${produto._id}`
                                                      );
                                                    }}
                                                  >
                                                    <span
                                                      className="float-left w-100"
                                                      style={{
                                                        color: "#5f9f1a",
                                                        fontWeight: "bold",
                                                        display: "block",
                                                      }}
                                                    >
                                                      #{produto.cod} -{" "}
                                                      {produto.desc}
                                                    </span>
                                                  </a>
                                                </div>
                                                <div
                                                  className="product-variation__details float-left w-100"
                                                  style={{
                                                    position: "relative",
                                                  }}
                                                >
                                                  <div className="product-variation__price float-left w-100">
                                                    <span className="product-variation__final-price">
                                                      Estoque:{" "}
                                                      {produto.estoque.qtd}{" "}
                                                      {produto.unid}
                                                      <br />
                                                    </span>
                                                    <span className="product-variation__final-price">
                                                      Embalagem:{" "}
                                                      {produto.preco.embPadrao}{" "}
                                                      {produto.unid}
                                                    </span>
                                                    <br />
                                                    <div className="product-variation__final-price">
                                                      <div
                                                        className="d-flex"
                                                        style={{
                                                          marginTop: "5px",
                                                          justifyContent:
                                                            "center",
                                                        }}
                                                      >
                                                        <span
                                                          style={{
                                                            fontWeight: "bold",
                                                            fontSize: "20px",
                                                            color: "green",
                                                          }}
                                                        >
                                                          R${" "}
                                                          {formatarReal(
                                                            produto.preco
                                                              .precoUnitComImpostos
                                                          )}
                                                        </span>
                                                        <span
                                                          className="font-13 width-100 no-border-radius btn-negociar btn-negociar-new"
                                                          onClick={(e) =>
                                                            this.handleClickValores(
                                                              produto
                                                            )
                                                          }
                                                        ></span>
                                                      </div>
                                                      {/* <div>
                                                        Valor total: R$0,00
                                                      </div> */}
                                                    </div>

                                                    {/* <div className="product-variation__fractional-desc">
                                                      <span>
                                                        Preço por Unidade R$
                                                        2,127
                                                      </span>
                                                    </div> */}
                                                  </div>
                                                </div>

                                                <div
                                                  className="product-variation__actions"
                                                  style={{
                                                    position: "relative",
                                                  }}
                                                >
                                                  <div
                                                    className="product-actions"
                                                    data-variant-id="34883"
                                                    data-compra-minima="1"
                                                    data-multiplos="1"
                                                    data-stock="14"
                                                    data-compra-maxima=""
                                                    data-is-fractional="0"
                                                    data-price="6.38"
                                                  >
                                                    <div className="col-xs-12 no-padding">
                                                      <div className="product-variation__add-actions product-add-actions product-add-actions-34883">
                                                        <div
                                                          style={{
                                                            fontSize: 0,
                                                            whiteSpace:
                                                              "nowrap",
                                                          }}
                                                        >
                                                          <button
                                                            id="btn-qtd-minus-34883"
                                                            type="button"
                                                            className="button button-default less-padding product-variation__add-cart"
                                                            data-operation="-"
                                                            style={{
                                                              display: "none",
                                                            }}
                                                          >
                                                            -
                                                          </button>
                                                          <button
                                                            id="btn-qtd-plus-34883"
                                                            type="button"
                                                            className="button button-default less-padding product-variation__add-cart"
                                                            data-operation="+"
                                                            style={{
                                                              display: "none",
                                                            }}
                                                          >
                                                            +
                                                          </button>
                                                        </div>

                                                        <button
                                                          id="btn-update-qtd-cart-34883"
                                                          type="button"
                                                          className="button button-default less-padding product-variation__add-cart product-variation__add-cart-update product-add-34883"
                                                          style={{
                                                            display: "none",
                                                          }}
                                                        >
                                                          Atualizar
                                                        </button>
                                                      </div>
                                                    </div>
                                                  </div>
                                                </div>
                                              </article>{" "}
                                            </div>

                                            {/* </div>
                                             */}
                                          </React.Fragment>
                                        ))}

                                        {/* <button
                                          onClick={() => this.adicionarItens()}
                                        >
                                          feleip
                                        </button> */}
                                      </div>
                                    </div>
                                  </React.Fragment>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <Footer />
            </div>
          </div>
        </div>
      </React.Fragment>
    );
  }
}
